import { ProductPackage, RequestStatus, defaults } from 'typed/api';
import { deepAssign } from 'typed/utils';
import { combineReducers, entityAddReducer, entityLoadAllReducer, networkActionReducer, switchReducers } from './utils';

const
    csr = defaults.CompanySubscriptionReport,
    cma = defaults.NetworkArrayOf(defaults.CompanyAccessModule);

export default combineReducers({
    companyAccessModules: switchReducers(cma,
        entityLoadAllReducer(cma, 'LOAD_ALL_COMPANY_ACCESS_MODULES'),
        entityAddReducer(cma, 'ENABLE_COMPANY_ACCESS_MODULE'),
        (state, action) => {
            const nextState = state || cma;

            if (action.type === 'DISABLE_COMPANY_ACCESS_MODULE') {
                const active = action.payload.status === RequestStatus.SUCCEEDED ? { EndDate: null } : {};

                return deepAssign(nextState, {
                    Data: {
                        [nextState.Data.findIndex(({ ModuleID }) => ModuleID === action.payload.moduleID)]: {
                            Custom: {
                                status: action.payload.status
                            },
                            ...active
                        }
                    }
                });
            }

            return nextState;
        }
    ),
    companySubscription: switchReducers(csr,
        networkActionReducer(defaults.CompanySubscriptionReport, 'LOAD_COMPANY_SUBSCRIPTION_REPORT'),
        (state, action) => {
            let nextState = state || csr;

            if (action.type === 'LOAD_COMPANY_SUBSCRIPTION_REPORT' && action.payload.status === RequestStatus.SUCCEEDED) {
                return action.payload.response;
            }

            if (action.type === 'DELETE_USER_COMPANY_ACCESS_SUCCESS') {
                return csr;
            }

            if (nextState.ProductPackageID === ProductPackage.MONTHLY_MODULES ||
                nextState.ProductPackageID === ProductPackage.USER_ROLE_BASED_BILLING ||
                nextState.ProductPackageID === ProductPackage.SMART_STRATEGY) {
                if (action.type === 'ENABLE_COMPANY_ACCESS_MODULE') {
                    nextState = deepAssign(nextState, {
                        ServiceLevels: {
                            [nextState.ServiceLevels.getIndexByID(action.payload.entity.ID)]: {
                                Custom: {
                                    status: action.payload.status
                                }
                            }
                        }
                    });
                }

                if (action.type === 'DISABLE_COMPANY_ACCESS_MODULE') {
                    nextState = deepAssign(nextState, {
                        ServiceLevels: {
                            [nextState.ServiceLevels.getIndexByID(action.payload.moduleID)]: {
                                Custom: {
                                    status: action.payload.status
                                }
                            }
                        }
                    });
                }
            }

            if (action.type === 'EDIT_ALL_COMPANY_USER_SERVICE_LEVELS' ||
                action.type === 'SET_COMPANY_SUBSCRIPTION_LEVEL' ||
                action.type === 'DISABLE_COMPANY_SUBSCRIPTION_LEVEL' ||
                action.type === 'ENABLE_COMPANY_ACCESS_MODULE' ||
                action.type === 'DISABLE_COMPANY_ACCESS_MODULE' ||
                action.type === 'TOGGLE_SMART_STRATEGY_ACCESS_FUNCTIONALITY') {
                if (action.payload.status === RequestStatus.SUCCEEDED &&
                    (nextState.Custom.status === RequestStatus.SUCCEEDED || nextState.Custom.status === RequestStatus.FAILED)) {
                    return deepAssign(nextState, { Custom: { status: RequestStatus.UNSYNCED } });
                }
            }

            return nextState;
        }
    )
});
